import { memo, useState } from 'react';
import { ActionIcon, Box, ImageProps } from '@mantine/core';
import { IconX } from '@tabler/icons-react';

const styles = {
  container: {
    position: 'relative' as const,
    display: 'inline-block' as const,
  },
  deleteButton: {
    position: 'absolute' as const,
    top: 5,
    right: 5,
    opacity: 0,
    transition: 'opacity 200ms ease',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
  },
};

export const DeletableImage = memo(function DeletableImage({
  children,
  onDelete,
}: ImageProps & { children: React.ReactNode; onDelete: () => void }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      style={styles.container}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
      <ActionIcon
        style={{
          ...styles.deleteButton,
          opacity: isHovered ? 1 : 0,
        }}
        size="sm"
        color="red"
        onClick={onDelete}
        aria-label="Delete image"
      >
        <IconX size={14} />
      </ActionIcon>
    </Box>
  );
});
